import { render, staticRenderFns } from "./UsuarioReadNiveisAcesso.vue?vue&type=template&id=731cfe88&scoped=true&"
import script from "./UsuarioReadNiveisAcesso.vue?vue&type=script&lang=js&"
export * from "./UsuarioReadNiveisAcesso.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioReadNiveisAcesso.vue?vue&type=style&index=0&id=731cfe88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731cfe88",
  null
  
)

export default component.exports